<template>
  <a-drawer
    :title="title"
    :width="width"
    :visible="visible"
    :confirmLoading="confirmLoading"
    :destroyOnClose="true"
    :maskClosable="true"
    placement="right"
    @close="close"
    cancelText="关闭"
  >
    <a-spin :spinning="confirmLoading">
      <a-form :form="form">
        <a-form-item
          label="排序名称"
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
        >
          <a-input
            type="text"
            :max-length="30"
            v-decorator="[
              'sortName',
              {
                rules: [
                  { required: true, message: '请输入排序名称,限制30个字' },
                ],
              },
            ]"
            placeholder="请输入排序名称,限制30个字"
          ></a-input>
        </a-form-item>
        <a-form-item
          label="排序类型"
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
        >
          <a-input
            type="text"
            v-decorator="[
              'type',
              { rules: [{ required: true, message: '请输入排序类型' }] },
            ]"
            placeholder="请输入排序类型"
          ></a-input>
        </a-form-item>
        <!-- 选择基金 -->
        <a-form-item
          label="选择排序基金："
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
        >
          <a-select
            placeholder="请选择"
            v-decorator="['fundCodeList']"
            style="width: 210px"
            show-search
          >
            <a-select-option
              v-for="(item, index) in fundList"
              :key="index"
              :value="item.productCode"
            >
              {{ item.productCode }} / {{ item.productName }}
            </a-select-option>
          </a-select>
        </a-form-item>
      </a-form>
    </a-spin>
    <div class="drawer-bootom-button">
      <a-popconfirm
        title="确定放弃编辑？"
        @confirm="handleCancel"
        okText="确定"
        cancelText="取消"
      >
        <a-button style="margin-right: 0.8rem">取消</a-button>
      </a-popconfirm>
      <a-button @click="handleOk" type="primary">提交</a-button>
    </div>
  </a-drawer>
</template>

<script>
import { getAction, postTag } from '@/api/manage';
import pick from 'lodash.pick';
import JDate from '@/components/jeecg/JDate';
// import moment from 'moment';
import JMultiSelectTag from '../../../../components/dict/JMultiSelectTag';

export default {
  name: 'FundSortModal',
  components: {
    JDate,
    JMultiSelectTag,
  },
  props: {},
  data() {
    return {
      form: this.$form.createForm(this),
      title: '操作',
      width: 800,
      visible: false,
      labelValue: '',
      model: {},
      fundList: [],
      labelCol: {
        xs: { span: 24 },
        sm: { span: 5 },
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 16 },
      },
      confirmLoading: false,
      validatorRules: {},
      url: {
        add: process.env.VUE_APP_CMS_MARKETING + '/fundSort/add',
        edit: process.env.VUE_APP_CMS_MARKETING + '/fundSort/edit',
        fundList: process.env.VUE_APP_CMS_MARKETING + '/product/getProductList',
      },
    };
  },
  created() {
    this.getFundList();
  },
  /*watch: {
      model(newVal, oldVal) {
        this.reloadDataSource()
      }
    },*/
  methods: {
    add() {
      this.edit({});
    },
    edit(record) {
      console.log(record);
      this.form.resetFields();
      this.model = Object.assign({}, record);
      this.visible = true;
      if (this.model.id) {
        this.model.fundCodeList = this.model.fundCodeList.split(',');
      } else {
        this.model.fundCodeList = [];
      }
      this.$nextTick(() => {
        this.form.setFieldsValue(
          pick(this.model, 'sortName', 'type', 'fundCodeList')
        );
      });
    },
    close() {
      this.$emit('close');
      this.visible = false;
    },
    handleOk() {
      const that = this;
      // 触发表单验证
      this.form.validateFields((err, values) => {
        if (!err) {
          that.confirmLoading = true;
          let httpurl = '';
          if (!this.model.id) {
            httpurl += this.url.add;
          } else {
            httpurl += this.url.edit;
          }
          let formData = Object.assign(this.model, values);
          formData.fundCodeList = formData.fundCodeList.toString();
          console.log('表单提交数据', formData);
          postTag(httpurl, formData)
            .then((res) => {
              if (res.success) {
                that.$message.success(res.message);
                that.$emit('ok');
              } else {
                that.$message.warning(res.message);
              }
            })
            .finally(() => {
              that.confirmLoading = false;
              that.close();
            });
        }
      });
    },
    handleCancel() {
      this.close();
    },
    popupCallback(row) {
      this.form.setFieldsValue(pick(row, 'sortName', 'type', 'fundCodeList'));
    },
    getFundList() {
      getAction(this.url.fundList, {}).then((res) => {
        if (res.success) {
          this.fundList = res.result;
        }
      });
    },
  },
};
</script>
